module.exports = __webpack_public_path__ + "img/icon-link@3x.bfb76490.png";